import { Home, Search, Heart, User } from 'lucide-react';

interface MobileBottomNavProps {
  currentPage: string;
  onNavigate: (page: string) => void;
  favoriteCount: number;
  isLoggedIn: boolean;
  onOpenLogin: () => void;
}

export function MobileBottomNav({ currentPage, onNavigate, favoriteCount, isLoggedIn, onOpenLogin }: MobileBottomNavProps) {
  const items = [
    { id: 'home', label: 'Home', icon: Home },
    { id: 'catalog', label: 'Properties', icon: Search },
    { id: 'saved', label: 'Saved', icon: Heart, badge: favoriteCount },
    { id: 'profile', label: 'Profile', icon: User },
  ];

  const handleTap = (id: string) => {
    if (id === 'profile') {
      if (isLoggedIn) {
        // Navigate to whatever hub the user has access to
        onNavigate('hub');
      } else {
        onOpenLogin();
      }
    } else {
      onNavigate(id);
    }
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-border/50 bg-background/95 backdrop-blur-xl supports-[backdrop-filter]:bg-background/80">
      <div className="flex items-stretch justify-around h-16">
        {items.map((item) => {
          const isActive = item.id === currentPage || (item.id === 'catalog' && currentPage === 'detail');
          return (
            <button
              key={item.id}
              onClick={() => handleTap(item.id)}
              className={`flex flex-col items-center justify-center flex-1 min-w-[64px] min-h-[44px] gap-0.5 transition-colors relative ${
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              <div className="relative">
                <item.icon className={`w-5 h-5 ${isActive ? 'text-primary' : ''}`} />
                {item.badge != null && item.badge > 0 && (
                  <span className="absolute -top-1.5 -right-2.5 min-w-[16px] h-4 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center px-1">
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
              </div>
              <span className={`text-[10px] font-medium ${isActive ? 'text-primary' : ''}`}>
                {item.label}
              </span>
              {isActive && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full bg-primary" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}